'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require('./constants');
var defaultState = {
  error: false,
  policyId: undefined,
  loginId: undefined
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];
  if (action.type === _constants.actionTypes.SUBMIT_APPLICATION) {
    return Object.assign({}, state, action.data);
  }
  return state;
};